import Box from '@mui/material/Box';
import { teal } from '@mui/material/colors';
import { ConfirmDialogProvider, InfoDialogProvider } from '@qre-mailing/smart-table';
import { ToastContainer } from 'react-toastify';

import AppRouter from './routers/AppRouter';
import { defineStyle } from './theme';

const toastifyStyles = defineStyle({
  whiteSpace: 'break-spaces',
  lineHeight: 1.3,
  '& .Toastify__toast--warning': {
    backgroundColor: '#FFA500',
  },
  '& .Toastify__toast--success': {
    backgroundColor: teal['500'],
  },
});

export function App() {
  return (
    <>
      <InfoDialogProvider>
        <ConfirmDialogProvider>
          <AppRouter />
        </ConfirmDialogProvider>
      </InfoDialogProvider>
      <Box sx={toastifyStyles}>
        <ToastContainer position="bottom-right" hideProgressBar theme="colored" />
      </Box>
    </>
  );
}
